import { makeStyles } from "@alpha/ui-lib/theme";
import { Box } from '@alpha/ui-lib/ui/external';
import React from "react";
import CrossBorderWeb from "./CrossBorderWeb";
import MigrationOverviewBanner from "./MigrationOverviewBanner";
import MigrationTasks from "./MigrationTasks";
import AccountInformation from "./AccountInformation";
import FAQ from "./FAQ";
import { components } from "generated/payment-initialisation/schema";
import { CurrencyAccountDto } from '@alpha/currency-accounts-dtos';

export const useStyles = makeStyles(
    () => ({
    gridLayout: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridGap: '24px',
      alignItems: 'start',
      '@media (max-width: 600px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
        minWidth: '300px',
      },
    },
    leftColumn: {
      position: 'sticky',
      top: 172,
      gridRow: 'span 3',
      '@media (max-width: 600px)': {
        position: 'unset',
        top: 'unset',
        width: 'calc(100vw - 76px)',
      },
    },
    rightColumn: {
      gridColumn: 'span 2',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      '@media (max-width: 600px)': {
        width: 'calc(100vw - 76px)',
      },
    },
    accountInformation: {
      gridColumn: 'span 2',
    },
    }),
    { name: 'MigrationOverview' },
);
  
interface IProps {
  migrationReadiness: components['schemas']['MigrationReadinessResponse'];
  accountInfo: any;
  onNavigateToTab: (tabIndex: number) => void;
  currencyAccounts: CurrencyAccountDto[];
}

const MigrationOverview: React.FC<IProps> = ({ migrationReadiness, accountInfo, onNavigateToTab, currencyAccounts }) => {  
  const classes = useStyles();

  const corpayRequiredFields = (account: CurrencyAccountDto) => {
    return account.corpayAccountReference && account.corpayAccountCurrency;
  };
  
  return (
    <>
    <MigrationOverviewBanner />
      <Box className={classes.gridLayout}>
        <Box className={classes.leftColumn}>
          <MigrationTasks migrationReadiness={migrationReadiness} accountInfo={accountInfo} onNavigateToTab={onNavigateToTab} />
        </Box>
        <Box className={classes.rightColumn}>
          <CrossBorderWeb />
          {currencyAccounts.some((a) => corpayRequiredFields(a)) && <AccountInformation currencyAccounts={currencyAccounts} />}
          <FAQ />
        </Box>
    </Box>
    </>
  )
};

export default MigrationOverview;